module.exports = __webpack_public_path__ + "static/media/laVozKids.a11cf384.png";